import { type ReactNode } from 'react'
import styles from './ContentView.module.css'

export interface ContentViewProps {
  children: ReactNode
}

export function ContentView({ children }: ContentViewProps) {
  return <div className={styles.root}>{children}</div>
}

export interface SplitContentViewProps {
  leftSide: ReactNode
  tab: ReactNode
}

export function SplitContentView({ leftSide, tab }: SplitContentViewProps) {
  return (
    <div className={styles.container}>
      <div className={styles.leftSide}>{leftSide}</div>

      <div className={styles.tabs}>{tab}</div>
    </div>
  )
}
